<div class="kee-gallery {{class}}">
	<ul #container class="g-container">
		<li *ngFor="let image of images" #imgs>
			<img [src]="image.src" [attr.data-src]="image.dataSrc" [class]="image.class" data-loader="load" alt="{{image.alt}}" />
		</li>
	</ul>
</div>